module.exports = __webpack_public_path__ + "img/photosession_1_8.6513798e.jpg";